var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.version)?_c('div',[_c('div',{staticClass:"version-advice"},[_vm._v(_vm._s(_vm.version))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }